import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

import { PopoverService } from './popover.service';
declare var $:any;

@Component({
    selector: 'app-popover',
    templateUrl: 'popover.component.html',
    standalone: false
})
export class PopoverComponent implements OnInit {

    @Input() position: string = 'right'; // left or right
    @Input() id: string = '1';
    @Output() onClosed: EventEmitter<any> = new EventEmitter<any>();

    public showPopover: boolean;
    public get isVisible():boolean {
        return this.showPopover;
    }

    constructor(private popoverService: PopoverService) {
        this.showPopover = false;
        if (this.position !== 'left' && this.position !== 'right') {
            this.position = 'rigth';
        }
    }

    ngOnInit() {
        this.popoverService.onClosePopovers.subscribe(id => {
            if (id !== this.id) {
                this.showPopover = false;
            }
        });
        this.popoverService.onOpenPopover.subscribe(id => {
            if (id === this.id) {
                this.show();
            }
        });
    }

    public show() {
        this.showPopover = true;
        this.focusCloseBtn();
        this.popoverService.closeOtherPopovers(this.id);
    }

    public hide() {
        this.showPopover = false;
        this.onClosed.emit(null);
    }

    public toggle() {
        this.showPopover = !this.showPopover;
        if (this.showPopover) {
            this.focusCloseBtn();
            this.popoverService.closeOtherPopovers(this.id);
        } else {
            this.onClosed.emit(null);
        }
    }

    /**
     * Sets a timeout so the element can come into view
     * and then focuses the close button
     */
    private focusCloseBtn() {
        setTimeout(() => {
            let element = document.getElementById(this.id + 'BtnClosePopover');
            if (element !== null) {
                element.focus();
            }
        }, 100);
    }

}
